import { render, staticRenderFns } from "./DetailBerita.vue?vue&type=template&id=cee990d6&scoped=true"
import script from "./DetailBerita.vue?vue&type=script&lang=js"
export * from "./DetailBerita.vue?vue&type=script&lang=js"
import style0 from "./DetailBerita.vue?vue&type=style&index=0&id=cee990d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee990d6",
  null
  
)

export default component.exports